module.exports = __webpack_public_path__ + "static/media/_MIC2518.thumbnail.712e8bca.png";